// import React, { useEffect, useRef, useState } from "react";
// import * as S from "./TransducerView.style";
// import { useTranslation } from "react-i18next";

// // Components
// import Transducer from "./components/transducer";
// import TransductionActions from "./components/transductionActions";
// import Modal from "../../../utils/modal";
// import ZaiaModalResponseContent from "../../zaiaComponents/zaiaModalResponseContent";
// import NewTransducer from "./components/newtransducer";
// import TransducerWhisper from "./components/transducerWhisper";
// import TransducerGoogleChirp from "./components/transducerGoogleChirp";
// import TransducerGoogleChirp3 from "./components/transducerGoogleChirp3";
// import TransducerGoogleChirp2 from "./components/transducerGoogleChirp2";
// import ZaiaSelect from "../../zaiaComponents/zaiaSelect";
// import TransducerGoogleChirp1 from "./components/transducerGoogleChirp1";

// // assets
// const defaultUser = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaImgDefault/default-user.png`;
// const temporal = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaReactions/reaction-mail.svg`;

// function TransducerView({
//   closeFunc,
//   maxHeight,
//   maxViewActived,
//   setMaxViewActived,
//   minimizeActived,
//   setMinimizeActived,
//   changeView,
//   completeViewActived,
//   resetDisabled,
//   setActiveSelectionView
// }) {    
//   const {t, i18n: { language }} = useTranslation("global");
//   const [transducerState, setTransducerState] = useState(null);
//   const [transducerType, setTransducerType] = useState(null);
//   const [manageTransductionActived, setManageTransductionActive] = useState(false);
//   const [manageTransductionActivedConfirmation, setManageTransductionActivedConfirmation] = useState(false);
//   const [closeConfirmation, setCloseConfirmation] = useState(false);
//   const [recordingActived, setRecordingActived] = useState(false);
//   const [chirpVersion, setChirpVersion] = useState(1);
  
//   const transducerTypes = [
//     {
//       id: 1,
//       name: t("transductor.advancedNoteTaking"),
//       description: t("transductor.advancedNoteTakingDescription")
//     },
//     {
//       id: 2,
//       name: t("transductor.medicalConsultation"),
//       description: t("transductor.medicalConsultationDescription")
//     }
//   ] 	

//   console.log("no one noticed", transducerState);
  

//   if(minimizeActived) {
//     return (
//       <S.TransducerView>
//         <div className="transducer-minimized">
//           <div className="transducer-minimized__top">
//             <div className="transducer-minimized__buttons">
//               <button className="circle-button circle-button--close-notes"
//                 onClick={() => closeFunc()}
//               >
//                 <i className="circle-button__icon icon zaia-icono-cerrar"></i>
//               </button>
//               <button className="circle-button circle-button--maximize-notes"
//                 onClick={() => setMinimizeActived(false)}
//               >
//                 <i className="circle-button__icon icon zaia-i-up"></i>
//               </button>
//             </div>
//             <div className="transducer-minimized__text">
//               <div className="title">
//                 {t("transductor.sessionInProgress")}
//               </div>
//               <div className="subtitle">
//                 {t("transductor.medicalConsultation")}
//               </div>
//             </div>
//             <div className="transducer-minimized__state">
//               <div className="transductor-state">
//                 {
//                   transducerState === 'listening' && transducerState !== 'connecting' &&
//                   <div className='mic-container'>
//                   </div>
//                 }
//                 {
//                   transducerState === 'connecting' &&
//                   <i className="transductor-state__icon icon zaia-i-refresh"></i>
//                 }
//                 {
//                   transducerState === 'error' &&
//                   <i className="transductor-state__icon icon zaia-i-alert"></i>
//                 }
//                 {
//                   transducerState === 'paused' &&
//                   <i className="transductor-state__icon icon zaia-i-paused"></i>
//                 }
//                 <div className="transductor-state__text">
//                   {
//                     transducerState === 'listening' ? `${t("transductor.listening")}...` :
//                     transducerState === 'paused' ? t("transductor.paused") :
//                     transducerState === 'connecting' ? `${t("transductor.connecting")}...` :
//                     transducerState === 'error' ? t("transductor.error") : ""
//                   }
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </S.TransducerView>
//     )
//   }

//   return (
//     <S.TransducerView
//       maxViewActived={maxViewActived}
//       recordingActived={recordingActived}
//     >
//       <Modal
//         open={manageTransductionActivedConfirmation}
//       >
//         <S.ModalResponse>
//           <div className="modal-background" onClick={() => setManageTransductionActivedConfirmation(false)}>
//           </div>
//           <div className="modal-container">
//               <ZaiaModalResponseContent
//                 button1={() => {
//                   setManageTransductionActive(true);
//                   setManageTransductionActivedConfirmation(false);
//                   setMaxViewActived(true);
//                   setRecordingActived(false);
//                 }}
//                 button2={() => setManageTransductionActivedConfirmation(false)}
//                 doubleButton={true}
//                 formSuccess={false}
//                 otherImg={temporal}
//                 button1Text={t("globally.yes")}
//                 button2Text={t("globally.no")}
//                 title={t("transductor.finalizeSessionConfirmation")}
//                 subtitle={t("transductor.finalizeSessionConfirmationSub")}
//                 completeScreen={true}
//               />
//           </div>
//         </S.ModalResponse>
//       </Modal>
//       <Modal
//         open={closeConfirmation}
//       >
//         <S.ModalResponse>
//           <div className="modal-background" onClick={() => setCloseConfirmation(false)}>
//           </div>
//           <div className="modal-container">
//               <ZaiaModalResponseContent
//                 button1={() => {
//                   closeFunc();
//                   setCloseConfirmation(false);
//                 }}
//                 button2={() => setCloseConfirmation(false)}
//                 doubleButton={true}
//                 formSuccess={false}
//                 button1Text={t("followUp.confirm")}
//                 button2Text={t("globally.cancel")}
//                 title={t("transductor.closeSessionConfirmation")}
//                 subtitle={t("transductor.closeSessionConfirmationSub")}
//               />
//           </div>
//         </S.ModalResponse>
//       </Modal>
//       <div className="transductor">
//         <Header 
//           maxViewActived={maxViewActived}
//           setMaxViewActived={setMaxViewActived}
//           minimizeActived={minimizeActived}
//           setMinimizeActived={setMinimizeActived}
//           transducerState={transducerState}
//           transducerType={transducerType}
//           manageTransductionActived={manageTransductionActived}
//           recordingActived={recordingActived}
//           setRecordingActived={setRecordingActived}
//           transducerTypes={transducerTypes}
//           setCloseConfirmation={setCloseConfirmation}
//           changeView={changeView}
//           completeViewActived={completeViewActived}
//           resetDisabled={resetDisabled}
//           setActiveSelectionView={setActiveSelectionView}
//         />
//         {
//           !recordingActived && !manageTransductionActived &&
//           <div className="select-chirp-version">
//             <ZaiaSelect
//               type="select"
//               setValue={setChirpVersion}
//               value={chirpVersion}
//               items={[
//                 // { value: 3, text: 'Google Chirp 3' },
//                 // { value: 2, text: 'Google Chirp 2' },
//                 { value: 1, text: 'Google Chirp 3' },
//               ]}
//               shadow={false}
//               fontSize="13px"
//               backgroundColor={"#FFFFFF"}
//               borderRadius={"10px"}
//               heightList={"200px"}
//               textColor={"#6C6BCC"}
//               arrowColor={"#6C6BCC"}
//               borderColor={"#FFFFFF"}
//               textItemsColor={"#111111"}
//             />
//           </div>
//         }
//         <div className="transductor-container">
//           <TransductorContent 
//             maxViewActived={maxViewActived}
//             manageTransductionActived={manageTransductionActived}
//             transducerTypes={transducerTypes}
//             transducerType={transducerType}
//             setTransducerType={setTransducerType}
//             recordingActived={recordingActived}
//             setRecordingActived={setRecordingActived}
//             transducerState={transducerState}
//             setTransducerState={setTransducerState}
//             setManageTransductionActiveConfirmation={setManageTransductionActivedConfirmation}
//             chirpVersion={chirpVersion}
//           />
//         </div>
//       </div>
//     </S.TransducerView>
//   );
// }

// const Header = ({ 
//   maxViewActived,
//   setMaxViewActived,
//   setMinimizeActived,
//   transducerState,
//   transducerType,
//   manageTransductionActived,
//   recordingActived,
//   setRecordingActived,
//   transducerTypes,
//   setCloseConfirmation,
//   changeView,
//   completeViewActived,
//   resetDisabled,
//   setActiveSelectionView
// }) => {

//   const {t, i18n: { language }} = useTranslation("global");

//   return (
//     <S.HeaderDiv
//       maxViewActived={maxViewActived}
//     >
//       <div className="header">
//         <div className="header__top">
//           <div className="header__left">
//             {
//               !completeViewActived &&
//               <div className="header__close-chat" onClick={() => setCloseConfirmation(true)}>
//                 <i className="header__close-chat-icon icon zaia-icono-cerrar" />
//               </div>
//             }
//             {
//               !manageTransductionActived && !completeViewActived &&
//               <div className="header__max" onClick={() => setMaxViewActived(!maxViewActived)}>
//                 {
//                   maxViewActived
//                   ? <i className="header__max-icon icon zaia-icono-flechas-arriba-abajo ~changeicon" />
//                   : <i className="header__max-icon icon zaia-i-size" />
//                 }
//               </div>
//             }
//             {
//               !resetDisabled &&
//               <div className="header__reset-button" onClick={() => setActiveSelectionView(true)}>{t("chatbotAI.reset")}</div>
//             }
//             {
//               recordingActived && !completeViewActived &&
//               <div className="header__minimize"
//                 onClick={() => setMinimizeActived(true)}
//               >
//                 <i className="header__minimize-icon icon zaia-icono-dropdown-light" />
//                 <div className="header__minimize-text">{t("globally.minimize")}</div>
//               </div>
//             }
//           </div>
//           {
//             manageTransductionActived &&
//             <div className="header__center">
//               {t("transductor.manageTransduction")}...
//             </div>
//           }
//           <div className="header__right">
//             {
//               manageTransductionActived &&
//               <div className="header__type-transductor">
//                 {t("transductor.transductorMode")} <b>
//                   {
//                     transducerTypes.find(type => type.id === transducerType)?.name
//                   }
//                 </b>
//               </div>
//             }
//             {
//               !manageTransductionActived &&
//               <div className="header__title">
//                 <i className="header__title-icon icon zaia-document"></i>
//                 <div className="header__title-text">{
//                   t("globally.transductor")
//                 }</div>
//               </div>
//             }
//           </div>
//         </div>
//         { 
//           transducerType && recordingActived && !manageTransductionActived &&
//           <div className="header__bottom">
//             <div className="header__left">
//               <div className="transductor-type">
//                 {t("transductor.transductorMode")} <b>
//                   {
//                     transducerTypes.find(type => type.id === transducerType)?.name
//                   }
//                 </b>
//               </div>
//             </div>
//             <div className="header__right">
//               <div className="transductor-state">
//                 {
//                   (transducerState === 'listening' || transducerState === 'connecting') &&
//                   // <div className="transductor-state__circle"></div>
//                   <div className='mic-container'>
//                     {/* <i className='mic-icon icon zaia-microphone'/> */}
//                   </div>
//                 }
//                 {
//                   (transducerState === 'paused' || transducerState === 'error') &&
//                   <i className="transductor-state__icon icon zaia-i-paused"></i>
//                 }
//                 <div className="transductor-state__text">
//                   {
//                     transducerState === 'listening' ? `${t("transductor.listening")}...` :
//                     transducerState === 'paused' ? t("transductor.paused") :
//                     transducerState === 'connecting' ? `${t("transductor.connecting")}...` :
//                     transducerState === 'error' ? t("transductor.error") : ""
//                   }
//                 </div>
//               </div>
//             </div>
//           </div>
//         }
//       </div>
//     </S.HeaderDiv>
//   );
// };

// const TransductorContent = ({
//   manageTransductionActived,
//   transducerTypes,
//   transducerType,
//   setTransducerType,
//   recordingActived,
//   setRecordingActived,
//   transducerState,
//   setTransducerState,
//   setManageTransductionActiveConfirmation,
//   chirpVersion
// }) => {

//   const {t, i18n: { language }} = useTranslation("global");
//   const [messages, setMessages] = useState([]);
//   const [transcription, setTranscription] = useState("");

//   if(!manageTransductionActived) {
//     // return <Transducer
//     //   transducerTypes={transducerTypes}
//     //   transducerType={transducerType}
//     //   setTransducerType={setTransducerType}
//     //   recordingActived={recordingActived}
//     //   setRecordingActived={setRecordingActived}
//     //   transducerState={transducerState}
//     //   setTransducerState={setTransducerState}
//     //   setManageTransductionActiveConfirmation={setManageTransductionActiveConfirmation}
//     //   messages={messages}
//     //   setMessages={setMessages}
//     //   transcription={transcription}
//     //   setTranscription={setTranscription}
//     // />

//     if(chirpVersion === 1) {
//       return <TransducerGoogleChirp1
//       transducerTypes={transducerTypes} 
//       transducerType={transducerType}
//       setTransducerType={setTransducerType}
//       recordingActived={recordingActived}
//       setRecordingActived={setRecordingActived}
//       transducerState={transducerState}
//       setTransducerState={setTransducerState}
//       setManageTransductionActiveConfirmation={setManageTransductionActiveConfirmation}
//       messages={messages}
//       setMessages={setMessages}
//       transcription={transcription}
//       setTranscription={setTranscription}
//     /> 
//     } 
//     // else if(chirpVersion === 2) {
//     //   return <TransducerGoogleChirp2
//     //   transducerTypes={transducerTypes}
//     //   transducerType={transducerType}
//     //   setTransducerType={setTransducerType}
//     //   recordingActived={recordingActived}
//     //   setRecordingActived={setRecordingActived}
//     //   transducerState={transducerState}
//     //   setTransducerState={setTransducerState}
//     //   setManageTransductionActiveConfirmation={setManageTransductionActiveConfirmation}
//     //   messages={messages}
//     //   setMessages={setMessages}
//     //   transcription={transcription}
//     //   setTranscription={setTranscription}
//     // />
//     // } else if (chirpVersion === 3) {
//     //   return <TransducerGoogleChirp3
//     //     transducerTypes={transducerTypes}
//     //     transducerType={transducerType}
//     //     setTransducerType={setTransducerType}
//     //     recordingActived={recordingActived}
//     //     setRecordingActived={setRecordingActived}
//     //     transducerState={transducerState}
//     //     setTransducerState={setTransducerState}
//     //     setManageTransductionActiveConfirmation={setManageTransductionActiveConfirmation}
//     //     messages={messages}
//     //     setMessages={setMessages}
//     //     transcription={transcription}
//     //     setTranscription={setTranscription}
//     //   />
//     // }
//   } else {
//     return <TransductionActions
//       messages={messages}
//       setMessages={setMessages}
//       transducerType={transducerType}
//       transcription={transcription}
//       setTranscription={setTranscription}
//     />
//   }
// }

// export default TransducerView;



import React, { useEffect, useRef, useState } from "react";
import * as S from "./TransducerView.style";
import { useTranslation } from "react-i18next";

// Components
import Transducer from "./components/transducer";
import TransductionActions from "./components/transductionActions";
import Modal from "../../../utils/modal";
import ZaiaModalResponseContent from "../../zaiaComponents/zaiaModalResponseContent";
import NewTransducer from "./components/newtransducer";
import TransducerWhisper from "./components/transducerWhisper";
import TransducerGoogleChirp from "./components/transducerGoogleChirp";
import TransducerGoogleChirp3 from "./components/transducerGoogleChirp3";
import TransducerGoogleChirp2 from "./components/transducerGoogleChirp2";
import ZaiaSelect from "../../zaiaComponents/zaiaSelect";
import TransducerGoogleChirp1 from "./components/transducerGoogleChirp1";

// assets
const defaultUser = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaImgDefault/default-user.png`;
const temporal = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaReactions/reaction-mail.svg`;

function TransducerView({
  closeFunc,
  maxHeight,
  maxViewActived,
  setMaxViewActived,
  minimizeActived,
  setMinimizeActived,
  changeView,
  completeViewActived,
  resetDisabled,
  setActiveSelectionView
}) {    
  const {t, i18n: { language }} = useTranslation("global");
  const [transducerState, setTransducerState] = useState(null);
  const [transducerType, setTransducerType] = useState(null);
  const [manageTransductionActived, setManageTransductionActive] = useState(false);
  const [manageTransductionActivedConfirmation, setManageTransductionActivedConfirmation] = useState(false);
  const [closeConfirmation, setCloseConfirmation] = useState(false);
  const [recordingActived, setRecordingActived] = useState(false);
  const [chirpVersion, setChirpVersion] = useState(1);
  
  const transducerTypes = [
    {
      id: 1,
      name: t("transductor.advancedNoteTaking"),
      description: t("transductor.advancedNoteTakingDescription")
    },
    {
      id: 2,
      name: t("transductor.medicalConsultation"),
      description: t("transductor.medicalConsultationDescription")
    }
  ]   

  if(minimizeActived) {
    return (
      <S.TransducerView>
        <div className="transducer-minimized">
          <div className="transducer-minimized__top">
            <div className="transducer-minimized__buttons">
              <button className="circle-button circle-button--close-notes"
                onClick={() => closeFunc()}
              >
                <i className="circle-button__icon icon zaia-icono-cerrar"></i>
              </button>
              <button className="circle-button circle-button--maximize-notes"
                onClick={() => setMinimizeActived(false)}
              >
                <i className="circle-button__icon icon zaia-i-up"></i>
              </button>
            </div>
            <div className="transducer-minimized__text">
              <div className="title">
                {t("transductor.sessionInProgress")}
              </div>
              <div className="subtitle">
                {t("transductor.medicalConsultation")}
              </div>
            </div>
            <div className="transducer-minimized__state">
              <div className="transductor-state">
                {
                  transducerState === 'listening' && transducerState !== 'connecting' &&
                  <div className='mic-container'>
                  </div>
                }
                {
                  transducerState === 'connecting' &&
                  <i className="transductor-state__icon icon zaia-i-refresh animate-spin"></i>
                }
                {
                  transducerState === 'error' &&
                  <i className="transductor-state__icon icon zaia-i-alert"></i>
                }
                {
                  transducerState === 'paused' &&
                  <i className="transductor-state__icon icon zaia-i-paused"></i>
                }
                <div className="transductor-state__text">
                  {
                    transducerState === 'listening' ? `${t("transductor.listening")}...` :
                    transducerState === 'paused' ? t("transductor.paused") :
                    transducerState === 'connecting' ? `${t("transductor.connecting")}...` :
                    transducerState === 'error' ? t("transductor.error") : ""
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </S.TransducerView>
    )
  }

  return (
    <S.TransducerView
      maxViewActived={maxViewActived}
      recordingActived={recordingActived}
    >
      <Modal
        open={manageTransductionActivedConfirmation}
      >
        <S.ModalResponse>
          <div className="modal-background" onClick={() => setManageTransductionActivedConfirmation(false)}>
          </div>
          <div className="modal-container">
              <ZaiaModalResponseContent
                button1={() => {
                  setManageTransductionActive(true);
                  setManageTransductionActivedConfirmation(false);
                  setMaxViewActived(true);
                  setRecordingActived(false);
                }}
                button2={() => setManageTransductionActivedConfirmation(false)}
                doubleButton={true}
                formSuccess={false}
                otherImg={temporal}
                button1Text={t("globally.yes")}
                button2Text={t("globally.no")}
                title={t("transductor.finalizeSessionConfirmation")}
                subtitle={t("transductor.finalizeSessionConfirmationSub")}
                completeScreen={true}
              />
          </div>
        </S.ModalResponse>
      </Modal>
      <Modal
        open={closeConfirmation}
      >
        <S.ModalResponse>
          <div className="modal-background" onClick={() => setCloseConfirmation(false)}>
          </div>
          <div className="modal-container">
              <ZaiaModalResponseContent
                button1={() => {
                  closeFunc();
                  setCloseConfirmation(false);
                }}
                button2={() => setCloseConfirmation(false)}
                doubleButton={true}
                formSuccess={false}
                button1Text={t("followUp.confirm")}
                button2Text={t("globally.cancel")}
                title={t("transductor.closeSessionConfirmation")}
                subtitle={t("transductor.closeSessionConfirmationSub")}
              />
          </div>
        </S.ModalResponse>
      </Modal>
      <div className="transductor">
        <Header 
          maxViewActived={maxViewActived}
          setMaxViewActived={setMaxViewActived}
          minimizeActived={minimizeActived}
          setMinimizeActived={setMinimizeActived}
          transducerState={transducerState}
          transducerType={transducerType}
          manageTransductionActived={manageTransductionActived}
          recordingActived={recordingActived}
          setRecordingActived={setRecordingActived}
          transducerTypes={transducerTypes}
          setCloseConfirmation={setCloseConfirmation}
          changeView={changeView}
          completeViewActived={completeViewActived}
          resetDisabled={resetDisabled}
          setActiveSelectionView={setActiveSelectionView}
        />
        {
          !recordingActived && !manageTransductionActived &&
          <div className="select-chirp-version">
            <ZaiaSelect
              type="select"
              setValue={setChirpVersion}
              value={chirpVersion}
              items={[
                { value: 1, text: 'Google Chirp 3' },
              ]}
              shadow={false}
              fontSize="13px"
              backgroundColor={"#FFFFFF"}
              borderRadius={"10px"}
              heightList={"200px"}
              textColor={"#6C6BCC"}
              arrowColor={"#6C6BCC"}
              borderColor={"#FFFFFF"}
              textItemsColor={"#111111"}
            />
          </div>
        }
        <div className="transductor-container">
          <TransductorContent 
            maxViewActived={maxViewActived}
            manageTransductionActived={manageTransductionActived}
            transducerTypes={transducerTypes}
            transducerType={transducerType}
            setTransducerType={setTransducerType}
            recordingActived={recordingActived}
            setRecordingActived={setRecordingActived}
            transducerState={transducerState}
            setTransducerState={setTransducerState}
            setManageTransductionActiveConfirmation={setManageTransductionActivedConfirmation}
            chirpVersion={chirpVersion}
          />
        </div>
      </div>
    </S.TransducerView>
  );
}

const Header = ({ 
  maxViewActived,
  setMaxViewActived,
  setMinimizeActived,
  transducerState,
  transducerType,
  manageTransductionActived,
  recordingActived,
  setRecordingActived,
  transducerTypes,
  setCloseConfirmation,
  changeView,
  completeViewActived,
  resetDisabled,
  setActiveSelectionView
}) => {

  const {t, i18n: { language }} = useTranslation("global");

  return (
    <S.HeaderDiv
      maxViewActived={maxViewActived}
    >
      <div className="header">
        <div className="header__top">
          <div className="header__left">
            {
              !completeViewActived &&
              <div className="header__close-chat" onClick={() => setCloseConfirmation(true)}>
                <i className="header__close-chat-icon icon zaia-icono-cerrar" />
              </div>
            }
            {
              !manageTransductionActived && !completeViewActived &&
              <div className="header__max" onClick={() => setMaxViewActived(!maxViewActived)}>
                {
                  maxViewActived
                  ? <i className="header__max-icon icon zaia-icono-flechas-arriba-abajo ~changeicon" />
                  : <i className="header__max-icon icon zaia-i-size" />
                }
              </div>
            }
            {
              !resetDisabled &&
              <div className="header__reset-button" onClick={() => setActiveSelectionView(true)}>{t("chatbotAI.reset")}</div>
            }
            {
              recordingActived && !completeViewActived &&
              <div className="header__minimize"
                onClick={() => setMinimizeActived(true)}
              >
                <i className="header__minimize-icon icon zaia-icono-dropdown-light" />
                <div className="header__minimize-text">{t("globally.minimize")}</div>
              </div>
            }
          </div>
          {
            manageTransductionActived &&
            <div className="header__center">
              {t("transductor.manageTransduction")}...
            </div>
          }
          <div className="header__right">
            {
              manageTransductionActived &&
              <div className="header__type-transductor">
                {t("transductor.transductorMode")} <b>
                  {
                    transducerTypes.find(type => type.id === transducerType)?.name
                  }
                </b>
              </div>
            }
            {
              !manageTransductionActived &&
              <div className="header__title">
                <i className="header__title-icon icon zaia-document"></i>
                <div className="header__title-text">{
                  t("globally.transductor")
                }</div>
              </div>
            }
          </div>
        </div>
        { 
          transducerType && recordingActived && !manageTransductionActived &&
          <div className="header__bottom">
            <div className="header__left">
              <div className="transductor-type">
                {t("transductor.transductorMode")} <b>
                  {
                    transducerTypes.find(type => type.id === transducerType)?.name
                  }
                </b>
              </div>
            </div>
            <div className="header__right">
              <div className="transductor-state">
                {
                  (transducerState === 'listening' || transducerState === 'connecting') &&
                  <div className='mic-container'>
                  </div>
                }
                {
                  (transducerState === 'paused' || transducerState === 'error') &&
                  <i className="transductor-state__icon icon zaia-i-paused"></i>
                }
                <div className="transductor-state__text">
                  {
                    transducerState === 'listening' ? `${t("transductor.listening")}...` :
                    transducerState === 'paused' ? t("transductor.paused") :
                    transducerState === 'connecting' ? `${t("transductor.connecting")}...` :
                    transducerState === 'error' ? t("transductor.error") : ""
                  }
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </S.HeaderDiv>
  );
};

const TransductorContent = ({
  manageTransductionActived,
  transducerTypes,
  transducerType,
  setTransducerType,
  recordingActived,
  setRecordingActived,
  transducerState,
  setTransducerState,
  setManageTransductionActiveConfirmation,
  chirpVersion
}) => {

  const {t, i18n: { language }} = useTranslation("global");
  const [messages, setMessages] = useState([]);
  const [transcription, setTranscription] = useState("");

  if(!manageTransductionActived) {
    if(chirpVersion === 1) {
      return <TransducerGoogleChirp1
      transducerTypes={transducerTypes} 
      transducerType={transducerType}
      setTransducerType={setTransducerType}
      recordingActived={recordingActived}
      setRecordingActived={setRecordingActived}
      transducerState={transducerState}
      setTransducerState={setTransducerState}
      setManageTransductionActiveConfirmation={setManageTransductionActiveConfirmation}
      messages={messages}
      setMessages={setMessages}
      transcription={transcription}
      setTranscription={setTranscription}
    /> 
    } 
  } else {
    return <TransductionActions
      messages={messages}
      setMessages={setMessages}
      transducerType={transducerType}
      transcription={transcription}
      setTranscription={setTranscription}
    />
  }
}

export default TransducerView;